export interface MentionListState {
  open: boolean;
  activeIndex: number;
}

export function shouldHandleComposerPromptKey(
  event: Pick<KeyboardEvent, "isComposing" | "keyCode">,
  withinOwnEditor: boolean
): boolean {
  return withinOwnEditor && !event.isComposing && event.keyCode !== 229;
}

export function moveMentionSelection(
  state: MentionListState,
  direction: -1 | 1,
  optionCount: number
): MentionListState {
  if (!state.open || optionCount <= 0) return { open: optionCount > 0, activeIndex: 0 };
  return {
    open: true,
    activeIndex: (state.activeIndex + direction + optionCount) % optionCount
  };
}

export function acceptMentionSelection<T>(
  options: readonly T[],
  activeIndex: number
): T | undefined {
  return options[activeIndex];
}

export function dismissMentionSelection(): MentionListState {
  return { open: false, activeIndex: 0 };
}
